const gps = {
    centerLatitude: null,
    centerLongitude: null,
    callback: null,

    // 現在位置から情報取得
    gps: function () {
        // geolocation に対応しているか否かを確認
        if ("geolocation" in navigator) {
            const opt = {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
            };
            navigator.geolocation.getCurrentPosition(
                function (pos) {
                    gps.centerLatitude = pos.coords.latitude;
                    gps.centerLongitude = pos.coords.longitude;
                    $(".js-gps").slideDown("slow");

                    if (typeof gps.callback === "function") {
                        gps.callback();
                    }
                },
                function (err) {
                    if (typeof gps.callback === "function") {
                        $(".js-gps").slideUp("slow");
                        gps.callback();
                    }
                },
                opt
            );
        } else {
            alert("ブラウザが位置情報取得に対応していません");
        }
    }
};

window.gps = gps;

// 初期起動で必ずGPS取得
$(document).ready(function (e) {
    gps.callback = distance.initReferencePosition;
    gps.gps();
});
